// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"65200d21","194":"a7314ff5","254":"3fd2183c","327":"eb98e319","440":"a221a0f8","452":"b12f9a90","515":"2841ccfe","860":"3461d592","991":"fdcb669c"}[chunkId] + ".chunk.js";
};